function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export const CubeIcon = (_0)=>{
    let { color } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "16",
        height: "18",
        viewBox: "0 0 16 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M15.4539 4.93179C15.4539 4.93179 15.4539 4.93179 15.4539 4.86109L15.4009 4.72854C15.3824 4.70041 15.3617 4.67381 15.3391 4.649C15.3154 4.6116 15.2888 4.57614 15.2595 4.54296L15.18 4.4811L15.0386 4.4104L8.4109 0.318895C8.2704 0.231112 8.10815 0.18457 7.94249 0.18457C7.7769 0.18457 7.61457 0.231112 7.47415 0.318895L0.899447 4.4104L0.819922 4.4811L0.740388 4.54296C0.711088 4.57614 0.684497 4.6116 0.660855 4.649C0.63813 4.67381 0.617447 4.70041 0.598997 4.72854L0.545972 4.86109C0.545972 4.86109 0.545972 4.8611 0.545972 4.93179C0.537288 5.00813 0.537288 5.0852 0.545972 5.16155V12.8851C0.545672 13.0352 0.583647 13.183 0.656322 13.3145C0.728988 13.4459 0.833955 13.5566 0.961313 13.6362L7.58899 17.7277C7.62982 17.7529 7.67465 17.7708 7.72157 17.7807C7.72157 17.7807 7.76574 17.7807 7.79224 17.7807C7.94182 17.8281 8.10232 17.8281 8.25182 17.7807C8.25182 17.7807 8.29599 17.7807 8.32249 17.7807C8.3694 17.7708 8.41424 17.7529 8.45507 17.7277L15.0386 13.6362C15.1659 13.5566 15.2709 13.4459 15.3436 13.3145C15.4162 13.183 15.4542 13.0352 15.4539 12.8851V5.16155C15.4626 5.0852 15.4626 5.00813 15.4539 4.93179ZM7.08532 15.3947L2.225 12.3902V6.7522L7.08532 9.74797V15.3947ZM7.96899 8.21914L3.02032 5.16155L7.96899 2.1128L12.9177 5.16155L7.96899 8.21914ZM13.7131 12.3902L8.85274 15.3947V9.74797L13.7131 6.7522V12.3902Z",
            fill: color
        })
    }));
};
